<template>
    <div class="invite" v-bind:class="{ 'hasWeddingAnimation' : hasAnimation, 'inviteIsClicked' : isClicked }" @click="clickInbjudan">
      <!--Lägger till eller tar bort klassen hasWeddingAnimation beroende på om komponenten Weddinganimation.vue har blivit mounted eller inte. Om denna komponent inte kommer att användas som wrapper för att byta innehåll, kan man helt enkelt lägga till klassen här.-->
      <Weddinganimation @has-animation="hasAnimationFunc" v-bind:hasAnimationC="hasAnimation"/>
    </div>

</template>

<script>
// @ is an alias to /src
import Weddinganimation from '@/components/Weddinganimation.vue';

export default {
  // name: 'HelloWorld'
  components: {
    Weddinganimation
    // man kan även skriva 'new-component-name' : Testcomponent om man vill använda ett nytt namn och få en garanterat unik selector till sin template
  },
  data: function () {
    return {
      hasAnimation: false,
      isClicked: false
    };
  },
  methods: {
    // kontrollerar om komponenten Weddinganimation.vue är med
    hasAnimationFunc (emittedvalue) {
      this.hasAnimation = emittedvalue;
      // console.log('hasAnimationFunc invite.vue ' + this.emittedvalue + ' hasAnimation: ' + this.hasAnimation);
      return this.hasAnimation;
    },

    // goToAbout: används i metoden clickInbjudan för att navigera
    goToAbout () {
      this.$router.push('/schema');
    },

    // klickar på inbjudningskortet
    clickInbjudan () {
      // lägger till klassen inviteIsClicked genom att sätta this.isClicked till true
      this.isClicked = true;

      // navigerar till aboutsidan efter en delay på samma längd som animationen i inviteIsClicked har
      // setTimeout(this.goToAbout, 1000);
      setTimeout(this.goToAbout, 500);
    }
  },
  mounted: function () {
    // kontrollerar om komponenten Weddinganimation.vue är med
    this.hasAnimationFunc(this.hasAnimation);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

